import { ModalSheet } from '@components/ModalSheet'
import AddSupporter from '../features/add-supporter/AddSupporter'
import type { Group, GroupCriteriaRule } from '@frontend/graphql/types.generated'
import type { SharedInertiaProps } from '../types/groupTypes'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('supporter_create')

type CriteriaRuleProps = Pick<GroupCriteriaRule, 'id' | 'predicate' | 'property' | 'values'>

type AddSupporterSheetProps = {
  group: Pick<Group, 'id' | 'name'>
  criteria: {
    combinator: Group['criteria']['combinator']
    rules: {
      nodes: CriteriaRuleProps[]
    }
  }
} & SharedInertiaProps

function AddSupporterSheet({ group, criteria, permissions }: AddSupporterSheetProps) {
  return (
    <ModalSheet.Root reloadOnClose={['supporters', 'newSupportersCount', 'group']}>
      <ModalSheet.Header title={t('title', { name: group.name })} />
      <ModalSheet.Body>
        <AddSupporter group={group} criteria={criteria} permissions={permissions} />
      </ModalSheet.Body>
    </ModalSheet.Root>
  )
}

export default AddSupporterSheet
